// extracted by mini-css-extract-plugin
export default {"background":"Curriculum_background__Xy5-2","textbookCardBody":"Curriculum_textbookCardBody__1p0lk","downUpArrow":"Curriculum_downUpArrow__bPOky"};